/* Deluxe v2: nav dropdowns, first-visit DELUXEFIRST pop-up, bulk enquiry prefill. */
(function () {
  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
  }

  // Close nav dropdowns on outside click / Escape; only one open at a time.
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.v2-dd[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details.v2-dd[open]').forEach(function (d) { d.removeAttribute('open'); d.querySelector('summary').focus(); });
  });

  // First-visit offer pop-up.
  var pop = document.querySelector('[data-v2-pop]');
  if (pop) {
    var posted = /[?&]customer_posted=true/.test(location.search) || pop.hasAttribute('data-posted');
    var last;
    function open() { last = document.activeElement; pop.hidden = false; var i = pop.querySelector('input[type=email]') || pop.querySelector('button'); if (i) i.focus(); }
    function close() { pop.hidden = true; store('dfx_v2_pop', String(Date.now())); if (last && last.focus) last.focus(); }
    pop.querySelectorAll('[data-v2-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    pop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key !== 'Tab') return;
      var f = pop.querySelectorAll('button, input, a[href]'); if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });
    // Floating "10% off" button: re-opens the pop-up; hidden once this browser has signed up.
    if (document.querySelector('.v2-signup .v2-code')) store('dfx_v2_joined', '1');
    var fab = document.querySelector('[data-v2-pop-open]');
    if (fab && !store('dfx_v2_joined')) {
      fab.hidden = false;
      fab.addEventListener('click', open);
    }
    if (pop.hasAttribute('data-show-result')) open();
    else if (!posted && !store('dfx_v2_pop') && !/[?&]view=|\/(cart|checkout)/.test(location.pathname + location.search)) {
      setTimeout(open, parseInt(pop.getAttribute('data-delay') || '6', 10) * 1000);
    }
  }

  // Product bulk box: carry the selected size into the enquiry link.
  document.querySelectorAll('[data-v2-bulk-link]').forEach(function (a) {
    a.addEventListener('click', function () {
      var form = document.querySelector('form[action*="/cart/add"]');
      var checked = document.querySelector('variant-picker input[type=radio]:checked, .variant-picker input[type=radio]:checked');
      var size = checked ? checked.value : '';
      if (!size && form) { var s = form.querySelector('select'); if (s) size = s.value; }
      if (size) { var u = new URL(a.href, location.origin); u.searchParams.set('size', size); a.href = u.pathname + u.search + u.hash; }
    });
  });
})();

/* Marquee pause buttons (announcement bar + brand strip). */
(function () {
  document.querySelectorAll('[data-v2-marquee-toggle]').forEach(function (btn) {
    var root = btn.closest('[data-v2-marquee]');
    var label = btn.getAttribute('aria-label');
    btn.addEventListener('click', function () {
      var paused = root.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? label.replace('Pause', 'Play') : label);
    });
  });
})();

/* Announcement bar: constant speed (px/s) whatever the message count, and each group is filled to at least the viewport width so the loop never shows a gap. */
(function () {
  document.querySelectorAll('.v2-tk[data-v2-tk-speed]').forEach(function (bar) {
    var viewport = bar.querySelector('.v2-tk__viewport');
    var groups = bar.querySelectorAll('.v2-tk__group');
    if (!viewport || !groups.length) return;
    var original = groups[0].innerHTML;
    var speed = parseFloat(bar.getAttribute('data-v2-tk-speed')) || 80;
    function fit() {
      groups.forEach(function (g) { g.innerHTML = original; });
      var w = groups[0].scrollWidth, n = 1;
      var w = groups[0].scrollWidth, n = 1;
      if (!w) return; // not laid out yet: keep the fallback loop time
      while (w > 0 && w * n < viewport.clientWidth && n < 20) n++;
      if (n > 1) groups.forEach(function (g) { g.innerHTML = new Array(n + 1).join(original); });
      groups.forEach(function (g, i) { if (i) g.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); }); });
      bar.style.setProperty('--v2-tk-duration', (groups[0].scrollWidth / speed).toFixed(2) + 's');
    }
    fit();
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 200); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  });
})();

/* Mobile menu: Horizon's header clips fixed children, so the panel is moved to <body> and shown while the burger is open. */
(function () {
  var burger = document.querySelector('details.v2-burger');
  if (!burger) return;
  var panel = burger.querySelector('.v2-burger__panel');
  var summary = burger.querySelector('summary');
  document.body.appendChild(panel);
  panel.hidden = true;
  function close() { burger.removeAttribute('open'); }
  burger.addEventListener('toggle', function () {
    panel.hidden = !burger.open;
    document.documentElement.style.overflow = burger.open ? 'hidden' : '';
    if (burger.open) { var f = panel.querySelector('a, button'); if (f) f.focus(); } else { summary.focus(); }
  });
  panel.querySelectorAll('[data-v2-burger-close]').forEach(function (b) { b.addEventListener('click', close); });
  panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) close(); });
})();

/* Hero slideshow: every few seconds roll the photo strip left by one page (3 photos); the track ends with copies of the first page,
   so after sliding onto them it snaps back to the start without a visible jump. */
(function () {
  var root = document.querySelector('[data-v2-hero]');
  if (!root) return;
  var track = root.querySelector('.v2-hero__track');
  var btn = root.querySelector('[data-v2-hero-toggle]');
  var pages = parseInt(root.getAttribute('data-pages') || '3', 10);
  var ms = parseInt(root.getAttribute('data-interval') || '5', 10) * 1000;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!track || pages < 2 || reduce) { if (btn) btn.hidden = true; return; }
  var page = 0, paused = false;
  function show(p, animate) {
    track.classList.toggle('is-anim', animate);
    track.style.transform = 'translateX(' + (-100 * p) + '%)';
  }
  track.addEventListener('transitionend', function (e) {
    if (e.target === track && page >= pages) { page = 0; show(0, false); }
  });
  setInterval(function () {
    if (paused || document.hidden) return;
    page += 1; show(page, true);
  }, ms);
  if (btn) btn.addEventListener('click', function () {
    paused = !paused;
    root.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', paused ? 'Play photo slideshow' : 'Pause photo slideshow');
  });
})();
